class Career extends HTMLElement {
  constructor() {
    super();
    // Select all filter links and table rows for filtering functionality
    this.filterLinks = this.querySelectorAll('.career-locations li a');
    this.tableRows = this.querySelectorAll('.career-list tbody tr');
  }

  connectedCallback() {
    // Attach click event listeners to filter links
    this.filterLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const selectedLocation = event.target.dataset.location;

        this.setActiveFilter(event.target); // Update the active filter styling

        // Use debounce to delay filtering for better performance
        this.debounce(() => {
          if (selectedLocation === 'all_location') {
            this.showAllRows(); // Show all rows if "All Locations" is selected
          } else {
            this.filterRowsByLocation(selectedLocation); // Filter rows by location
          }
        }, 200)();
      });
    });
  }

  showAllRows() {
    // Display all rows in the table
    this.tableRows.forEach((tr) => {
      tr.style.display = 'table-row';
    });
  }

  filterRowsByLocation(location) {
    // Show only rows matching the selected location
    this.tableRows.forEach((tr) => {
      if (tr.dataset.location.toLowerCase().trim() === location.toLowerCase().trim()) {
        tr.style.display = 'table-row';
      } else {
        tr.style.display = 'none';
      }
    });
  }

  setActiveFilter(selectedLink) {
    // Remove active class from all links and add it to the selected link
    this.filterLinks.forEach((link) => link.classList.remove('active'));
    selectedLink.classList.add('active');
  }

  debounce(func, delay) {
    // Utility function to delay execution of a function
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(func, delay);
    };
  }
}

// Define the custom element 'fx-career'
customElements.define('fx-career', Career);
